import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import { USER_REQUEST } from './store/actions/user'

Vue.use(Router);

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next();
    return
  }
  next('/home')
};

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next();
    return
  }
  next('/')
};

const canViewShipmentStatus = profile => profile && (
  profile.enable_shipments === true && (
    profile.roll === 5 ||
    (profile.roll === 1 && (
      profile.shipments_management === true ||
      profile.can_view_shipment_status === true
    ))
  )
)

const ifCanViewShipmentStatus = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next('/')
    return
  }

  const authorize = () => {
    if (canViewShipmentStatus(store.getters.getProfile)) {
      next()
    } else {
      next('/home')
    }
  }

  if (store.getters.isProfileLoaded) {
    authorize()
    return
  }

  store.dispatch(USER_REQUEST)
    .then(authorize)
    .catch(() => next('/'))
};

const ifBuildingAdmin = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next('/')
    return
  }

  const canAccess = profile => profile && profile.roll === 4 && profile.is_building === true
  if (store.getters.isProfileLoaded) {
    if (canAccess(store.getters.getProfile)) next()
    else next('/home')
    return
  }

  store.dispatch(USER_REQUEST)
    .then(() => {
      if (canAccess(store.getters.getProfile)) next()
      else next('/home')
    })
    .catch(() => next('/'))
};

const ifNotAdminFilesCompany = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next('/')
    return
  }

  if (store.getters.isProfileLoaded) {
    if (store.getters.getProfile.roll === 5) {
      next('/gestion_empresa')
      return
    }
    next()
    return
  }

  store.dispatch(USER_REQUEST)
    .then(() => {
      if (store.getters.getProfile.roll === 5) {
        next('/gestion_empresa')
      } else {
        next()
      }
    })
    .catch(() => {
      next('/')
    })
};

const ifAuthenticated_confirm = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next();
    return
  }
  localStorage.setItem('path_confirmed', to.path)
  // console.log('PATH = ', localStorage.getItem('path_confirmed'))
  next('/')
};

const ifAuthenticated_authorized_access = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next();
    return
  }
  localStorage.setItem('path_authorized_access', to.path)
  // console.log('PATH = ', localStorage.getItem('path_confirmed'))
  next('/')
};

const ifAuthenticated_authorized_access_no_code = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next();
    return
  }
  localStorage.setItem('path_authorized_access_no_code', to.path)
  // console.log('PATH = ', localStorage.getItem('path_confirmed'))
  next('/')
};

const ifSecurityAdmin = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next('/')
    return
  }
  
  // Si el perfil ya está cargado, verificar el roll
  if (store.getters.isProfileLoaded) {
    if (store.getters.getProfile.roll === 8) {
      next();
      return
    }
    next('/')
    return
  }
  
  // Si no está cargado, cargar el perfil primero
  store.dispatch(USER_REQUEST)
    .then(() => {
      if (store.getters.getProfile.roll === 8) {
        next();
      } else {
        next('/')
      }
    })
    .catch(() => {
      next('/')
    })
};

const ifCompanyOrParkSecurityAdmin = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next('/')
    return
  }

  const canAccess = profile => profile && ((profile.roll === 5 && profile.enable_security === true) || profile.roll === 4)

  // Si el perfil ya está cargado, verificar el roll
  if (store.getters.isProfileLoaded) {
    if (canAccess(store.getters.getProfile)) {
      next();
      return
    }
    next('/')
    return
  }

  // Si no está cargado, cargar el perfil primero
  store.dispatch(USER_REQUEST)
    .then(() => {
      if (canAccess(store.getters.getProfile)) {
        next();
      } else {
        next('/')
      }
    })
    .catch(() => {
      next('/')
    })
};

const ifVigilante = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next('/')
    return
  }

  // Si el perfil ya está cargado, verificar el roll
  if (store.getters.isProfileLoaded) {
    if (store.getters.getProfile.roll === 9) {
      next();
      return
    }
    next('/')
    return
  }

  // Si no está cargado, cargar el perfil primero
  store.dispatch(USER_REQUEST)
    .then(() => {
      if (store.getters.getProfile.roll === 9) {
        next();
      } else {
        next('/')
      }
    })
    .catch(() => {
      next('/')
    })
};

// Empresa host (roll 5) o superusuario con enable_security, y empleado supervisor
// de seguridad (roll 1 + security_supervisor): mismo criterio que canSeeSecurityCards
// en Home.vue para ver el módulo de seguridad de su propia empresa.
const canAccessHostSecurityDashboard = profile => {
  if (!profile) return false
  const isAdmin = profile.roll === 5 || profile.is_superuser === true
  const isSupervisorEmployee = profile.roll === 1 && profile.security_supervisor === true
  return profile.enable_security === true && (isAdmin || isSupervisorEmployee)
}

const ifSecurityGuard = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next('/')
    return
  }

  // Si el perfil ya está cargado, verificar el roll
  if (store.getters.isProfileLoaded) {
    if (store.getters.getProfile.roll === 9) {
      next();
      return
    }
    next('/')
    return
  }

  // Si no está cargado, cargar el perfil primero
  store.dispatch(USER_REQUEST)
    .then(() => {
      if (store.getters.getProfile.roll === 9) {
        next();
      } else {
        next('/')
      }
    })
    .catch(() => {
      next('/')
    })
};

const ifSecurityGuardWithActiveShift = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next('/')
    return
  }

  // Verificar rol y turno activo
  if (store.getters.isProfileLoaded) {
    const profile = store.getters.getProfile
    const isSecurityAdmin = profile && profile.roll === 8
    const isSecurityGuard = profile && profile.roll === 9

    // Admin sin restricción
    if (isSecurityAdmin) {
      next()
      return
    }

    // Empresa host / supervisor de seguridad: acceso sin restricción de turno
    if (canAccessHostSecurityDashboard(profile)) {
      next()
      return
    }

    // Guardia: requiere turno activo
    if (isSecurityGuard) {
      const activeShift = store.getters['security/getActiveShift']
      if (activeShift) {
        next()
        return
      }
      // Sin turno, redirigir a home
      next('/home')
      return
    }

    // Ni admin ni guardia, redirigir
    next('/')
    return
  }

  // Cargar perfil primero
  store.dispatch(USER_REQUEST)
    .then(() => {
      const profile = store.getters.getProfile
      const isSecurityAdmin = profile && profile.roll === 8
      const isSecurityGuard = profile && profile.roll === 9

      // Admin sin restricción
      if (isSecurityAdmin) {
        next()
        return
      }

      // Empresa host / supervisor de seguridad: acceso sin restricción de turno
      if (canAccessHostSecurityDashboard(profile)) {
        next()
        return
      }

      // Guardia: requiere turno activo
      if (isSecurityGuard) {
        const activeShift = store.getters['security/getActiveShift']
        if (activeShift) {
          next()
        } else {
          next('/home')
        }
        return
      }

      // Otros usuarios
      next('/')
    })
    .catch(() => {
      next('/')
    })
};

const ifVigilanteParque = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next('/')
    return
  }

  if (store.getters.isProfileLoaded) {
    if (store.getters.getProfile.roll === 3) {
      next();
      return
    }
    next('/')
    return
  }

  store.dispatch(USER_REQUEST)
    .then(() => {
      if (store.getters.getProfile.roll === 3) {
        next();
      } else {
        next('/')
      }
    })
    .catch(() => {
      next('/')
    })
};

const ifAuthenticated_concretar = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next();
    return
  }
  localStorage.setItem('path_concretar', to.path)
  // console.log('PATH = ', localStorage.getItem('path_concretar'))
  next('/')
};

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'login',
      component: () => import('./views/Login.vue'),
      beforeEnter: ifNotAuthenticated,
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('./views/Home.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/parques',
      name: 'parques',
      component: () => import('./views/superuser/parques.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/administradores_parque',
      name: 'administradores_parque',
      component: () => import('./views/superuser/administradores_parque.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/caseta_parque',
      name: 'caseta_parque',
      component: () => import('./views/superuser/caseta_parque.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/vigilante_parque',
      name: 'vigilante_parque',
      component: () => import('./views/superuser/vigilante_parque.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/companiesByPark',
      name: 'companiesByPark',
      component: () => import('./views/superuser/companiesByPark.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/empresas',
      name: 'empresas',
      component: () => import('./views/superuser/empresas.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/administradores',
      name: 'administradores',
      component: () => import('./views/superuser/administradores.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/empleados',
      name: 'empleados',
      component: () => import('./views/adminuser/empleados.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/proveedores',
      name: 'proveedores',
      component: () => import('./views/adminuser/proveedores.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/transportistas',
      name: 'transportistas',
      component: () => import('./views/adminuser/transportistas.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/clients',
      name: 'clients',
      component: () => import('./views/adminuser/clients.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/clients2',
      name: 'clients2',
      component: () => import('./views/adminuser/clients2.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/landing_areas',
      name: 'landing_areas',
      component: () => import('./views/adminuser/landing_areas.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/types_of_transport',
      name: 'types_of_transport',
      component: () => import('./views/adminuser/types_of_transport.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/admin_workers',
      name: 'admin_workers',
      component: () => import('./views/adminuser/admin_workers.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/print',
      name: 'print',
      component: () => import('./views/adminuser/print.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/areas',
      name: 'areas',
      component: () => import('./views/adminuser/areas.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/casetas',
      name: 'casetas',
      component: () => import('./views/adminuser/casetas.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/banned_people',
      name: 'banned_people',
      component: () => import('./views/adminuser/banned_people.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/vigilantes',
      name: 'vigilantes',
      component: () => import('./views/adminuser/vigilantes.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/invitacion',
      name: 'invitacion',
      component: () => import('./views/adminuser/invitacion.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/mockup',
      name: 'mockup',
      component: () => import('./views/adminuser/mockup.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/mockup2',
      name: 'mockup2',
      component: () => import('./views/adminuser/mockup2.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/mockup3',
      name: 'mockup3',
      component: () => import('./views/adminuser/mockup3.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/mockup4',
      name: 'mockup4',
      component: () => import('./views/adminuser/mockup4.vue'),
      beforeEnter: ifCanViewShipmentStatus,
    },
    {
      path: '/mockup5',
      name: 'mockup5',
      component: () => import('./views/adminuser/mockup5.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/operator_metrics',
      name: 'operator_metrics',
      component: () => import('./views/adminuser/operator_metrics.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/vehicles_management',
      name: 'vehicles_management',
      component: () => import('./views/adminuser/vehicles_management.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/personal_transport',
      name: 'personal_transport',
      component: () => import('./views/adminuser/personal_transport.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/advanced-shipments/carriers',
      name: 'carriers_management',
      component: () => import('./views/adminuser/advanced_shipments/carriers/index.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/advanced-shipments/evidence-emails',
      name: 'evidence_emails_management',
      component: () => import('./views/adminuser/advanced_shipments/evidence_emails/index.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/external-onboarding/:token',
      name: 'external_onboarding',
      component: () => import('./views/external-onboarding/index.vue'),
      // Sin protección de autenticación - acceso público con token
    },
    {
      path: '/onboarding/park-admin/:token',
      name: 'onboarding_park_admin',
      component: () => import('./views/onboarding/park-admin.vue'),
      // Sin protección de autenticación - acceso público con token
    },
    {
      path: '/onboarding/company/:token',
      name: 'onboarding_company',
      component: () => import('./views/onboarding/company.vue'),
      // Acceso público mediante token temporal
    },
    {
      path: '/corporate-building/company-onboarding',
      name: 'corporate_building_company_onboarding',
      component: () => import('./views/adminuser/corporate_building/company_onboarding.vue'),
      beforeEnter: ifBuildingAdmin,
    },
    {
      path: '/corporate-building/offices',
      name: 'corporate_building_offices',
      component: () => import('./views/adminuser/corporate_building/office_catalog.vue'),
      beforeEnter: ifBuildingAdmin,
    },
    {
      path: '/parking_space',
      name: 'parking_space',
      component: () => import('./views/adminuser/parking_space.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/corporate-building/parking-spaces-management',
      name: 'parking_spaces_management',
      component: () => import('./views/adminuser/corporate_building/parking_spaces_management.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/corporate-building/parking-spaces-assignment',
      name: 'parking_spaces_assignment',
      component: () => import('./views/adminuser/corporate_building/parking_spaces_assignment.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/company-parking-spaces',
      name: 'company_parking_spaces',
      component: () => import('./views/adminuser/company_parking_spaces.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/corporate-building/facial-devices',
      name: 'facial_devices',
      component: () => import('./views/adminuser/corporate_building/facial_devices.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/corporate-building/parking-cards-management',
      name: 'parking_cards_management',
      component: () => import('./views/adminuser/corporate_building/parking_cards_management.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/corporate-building/parking-spaces-status',
      name: 'parking_spaces_status',
      component: () => import('./views/adminuser/corporate_building/parking_spaces_status.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/vehicle_types',
      name: 'vehicle_types',
      component: () => import('./views/adminuser/vehicle_type.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/historial',
      name: 'historial',
      component: () => import('./views/adminuser/historial.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/entradas_salidas',
      name: 'entradas_salidas',
      component: () => import('./views/vigilante/entradas_salidas.vue'),
      beforeEnter: ifAuthenticated,
    },
    /*
        {
          path: '/access_parking',
          name: 'access_parking',
          component: () => import('./views/vigilante/access_parking.vue'),
          beforeEnter: ifAuthenticated,
        },
        {
          path: '/access_shipments',
          name: 'access_shipments',
          component: () => import('./views/vigilante/access_shipments.vue'),
          beforeEnter: ifAuthenticated,
        },
    */
    {
      path: '/check_in_out_employees',
      name: 'check_in_out_employees',
      component: () => import('./views/vigilante/check_in_out_employees.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/check_in_out',
      name: 'check_in_out',
      component: () => import('./views/vigilante_parque/check_in_out.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/camera_access',
      name: 'camera_access',
      component: () => import('./views/vigilante_parque/camera_access.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/acceso_sin_codigo',
      name: 'acceso_sin_codigo',
      component: () => import('./views/vigilante/acceso_sin_codigo.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/access_tutors',
      name: 'access_tutors',
      component: () => import('./views/vigilante/access_tutors.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/access_no_code',
      name: 'access_no_code',
      component: () => import('./views/vigilante_parque/access_no_code.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/bitacora',
      name: 'bitacora',
      component: () => import('./views/vigilante/bitacora.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/access_parking_records',
      name: 'access_parking_records',
      component: () => import('./views/adminuser/access_parking_records.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/access_shipments_records',
      name: 'access_shipments_records',
      component: () => import('./views/adminuser/access_shipments_records.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/bitacora_empresa',
      name: 'bitacora_empresa',
      component: () => import('./views/vigilante/bitacora_empresa.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/access/:tab',
      name: 'access',
      component: () => import('./views/vigilante/access'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/current_invitations',
      name: 'current_invitations',
      component: () => import('./views/vigilante/current_invitations.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/waiting_room',
      name: 'waiting_room',
      component: () => import('./views/vigilante/waiting_room.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/shipment_weigh_queue',
      name: 'shipment_weigh_queue',
      component: () => import('./views/vigilante/shipment_weigh_queue.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/security-reviews-pending',
      name: 'security_reviews_pending',
      component: () => import('./views/vigilante/security_reviews_pending.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/automatic_invitation',
      name: 'automatic_invitation',
      component: () => import('./views/vigilante/automatic_invitation'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/records_no_code',
      name: 'records_no_code',
      component: () => import('./views/vigilante_parque/records_no_code.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/active_invitations_park',
      name: 'active_invitations_park',
      component: () => import('./views/vigilante_parque/active_invitations.vue'),
      beforeEnter: ifVigilanteParque,
    },
    {
      path: '/files',
      name: 'files',
      component: () => import('./views/adminuser/files.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/files_company',
      name: 'files_company',
      component: () => import('./views/adminuser/files_company.vue'),
      beforeEnter: ifNotAdminFilesCompany,
    },
    {
      path: '/gestion_empresa',
      name: 'gestion_empresa',
      component: () => import('./views/adminuser/gestion_empresa.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/invitacion_tab',
      name: 'invitacion_tab',
      component: () => import('./views/adminuser/invitacion_tab.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/invitados_no_confirmados',
      name: 'invitados_no_confirmados',
      component: () => import('./views/adminuser/invitados_no_confirmados.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/invitados_no_confirmados2',
      name: 'invitados_no_confirmados2',
      component: () => import('./views/adminuser/invitados_no_confirmados2.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/firma_salida',
      name: 'firma_salida',
      component: () => import('./views/adminuser/firma_salida.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/authorize-access/:acceso_id',
      name: 'authorize_access',
      component: () => import('./views/adminuser/authorize_access.vue'),
      beforeEnter: ifAuthenticated_authorized_access,
    },
    {
      path: '/form_invitation_data/:token',
      name: 'form_invitation_data',
      component: () => import('./views/form_invitation_data.vue'),
      beforeEnter: ifAuthenticated_concretar,
    },
    {
      path: '/form_shipping_window_invitation_data/:token',
      name: 'form_shipping_window_invitation_data',
      component: () => import('./views/form_shipping_window_invitation_data.vue'),
      beforeEnter: ifAuthenticated_concretar,
    },
    {
      path: '/form_parking_invitation_data/:token',
      name: 'form_parking_invitation_data',
      component: () => import('./views/form_parking_invitation_data.vue'),
      beforeEnter: ifAuthenticated_concretar,
    },
    {
      path: '/form_invitation_park_data/:token',
      name: 'form_invitation_park_data',
      component: () => import('./views/form_invitation_park_data.vue'),
      beforeEnter: ifAuthenticated_concretar,
    },
    {
      path: '/emergencia',
      name: 'emergencia',
      component: () => import('./views/adminuser/emergencia.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/ayuda_admin',
      name: 'ayuda_admin',
      component: () => import('./views/adminuser/ayuda_admin.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/security/dashboard',
      name: 'security_dashboard',
      component: () => import('./views/adminuser/security/security_dashboard.vue'),
      beforeEnter: ifSecurityGuardWithActiveShift,
    },
    {
      path: '/security/register/:token',
      name: 'security_register',
      component: () => import('./views/adminuser/security/security_register.vue'),
    },
    {
      path: '/security/admin',
      name: 'security_admin_dashboard',
      component: () => import('./views/adminuser/security/security_admin_dashboard.vue'),
      beforeEnter: ifSecurityAdmin,
    },
    {
      path: '/security/pending-contracts',
      name: 'security_pending_contracts',
      component: () => import('./views/adminuser/security/security_pending_contracts.vue'),
      beforeEnter: ifSecurityAdmin,
    },
    {
      path: '/security/guards',
      name: 'security_guards',
      component: () => import('./views/adminuser/security/security_guards.vue'),
      beforeEnter: ifSecurityAdmin,
    },
    {
      path: '/security/roll-call',
      name: 'security_roll_call',
      component: () => import('./views/adminuser/security/security_roll_call.vue'),
      beforeEnter: ifSecurityAdmin,
    },
    {
      path: '/security/roll-call-history',
      name: 'security_roll_call_history',
      component: () => import('./views/adminuser/security/security_roll_call_history.vue'),
      beforeEnter: ifSecurityAdmin,
    },
    {
      path: '/security/shift-history',
      name: 'security_shift_history',
      component: () => import('./views/adminuser/security/security_shift_history.vue'),
      beforeEnter: ifSecurityAdmin,
    },
    {
      path: '/security/shifts',
      name: 'security_shifts',
      component: () => import('./views/adminuser/security/security_shifts.vue'),
      beforeEnter: ifSecurityGuardWithActiveShift,
    },
    {
      path: '/security/rounds',
      name: 'security_rounds',
      component: () => import('./views/adminuser/security/security_rounds.vue'),
      beforeEnter: ifSecurityGuardWithActiveShift,
    },
    {
      path: '/security/rounds/history',
      name: 'security_rounds_history',
      component: () => import('./views/adminuser/security/security_rounds_history.vue'),
      beforeEnter: ifVigilante,
    },
    {
      path: '/security/my-parks',
      name: 'security_my_parks',
      component: () => import('./views/adminuser/security/my_parks.vue'),
      beforeEnter: ifSecurityAdmin,
    },
    {
      path: '/security/link-company',
      name: 'security_link_company',
      component: () => import('./views/adminuser/security/link_security_company.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/security/assign-guards-to-park/:parkId',
      name: 'security_assign_guards_to_park',
      component: () => import('./views/adminuser/security/assign_guards_to_park.vue'),
      beforeEnter: ifSecurityAdmin,
    },
    {
      path: '/security/geofences',
      name: 'security_geofences',
      component: () => import('./views/adminuser/security/security_geofences.vue'),
      beforeEnter: ifCompanyOrParkSecurityAdmin,
    },
    {
      path: '/security/document-requests',
      name: 'security_document_requests',
      component: () => import('./views/adminuser/security/security_document_requests.vue'),
      beforeEnter: ifSecurityAdmin,
    },
    {
      path: '/security/document-requests/:requestId',
      name: 'security_document_request_detail',
      component: () => import('./views/adminuser/security/security_document_request_detail.vue'),
      beforeEnter: ifSecurityAdmin,
    },
    {
      path: '/security/my-documents',
      name: 'security_my_documents',
      component: () => import('./views/adminuser/security/security_my_documents.vue'),
      beforeEnter: ifSecurityGuard,
    },
    {
      path: '/security/messages',
      name: 'security_messages',
      component: () => import('./views/adminuser/security/security_messages.vue'),
      beforeEnter: ifSecurityAdmin,
    },
    {
      path: '/security/guard-messages',
      name: 'security_guard_messages',
      component: () => import('./views/adminuser/security/security_guard_messages.vue'),
      beforeEnter: ifSecurityGuard,
    },
    {
      path: '/visitas_pendientes',
      name: 'visitas_pendientes',
      component: () => import('./views/empleado/visitas_pendientes.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/grupos',
      name: 'grupos',
      component: () => import('./views/empleado/grupos.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/invitacion_tab_empleado',
      name: 'invitacion_tab_empleado',
      component: () => import('./views/empleado/invitacion_tab_empleado.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/terms_conditions',
      name: 'terms_conditions',
      component: () => import('./views/public/terms_conditions.vue')
    },
    {
      path: '/notice_privacy',
      name: 'notice_privacy',
      component: () => import('./views/public/notice_privacy.vue')
    },
    {
      path: '/actualizar_ine/:token',
      name: 'actualizar_ine',
      component: () => import('./views/public/actualizar_ine.vue')
    },
    {
      path: '/preregistro/:token',
      name: 'preregistro',
      component: () => import('./views/preregistro.vue'),
    },
    {
      path: '/preregistrov2/:token',
      name: 'preregistrov2',
      component: () => import('./views/preregistrov2.vue'),
    },
    {
      path: '/registro_usuario',
      name: 'registro_usuario',
      component: () => import('./views/vigilante/registro_usuario.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/create_user',
      name: 'create_user',
      component: () => import('./views/create_user.vue')
    },
    {
      path: '/preregistro_user_only_email/:token',
      name: 'preregistro_email',
      component: () => import('./views/preregistro_email.vue'),
    },
    {
      path: '/uploaddocumentation/:idInvitation/:idUser',
      name: 'upload_documentation_byinvitation_byuser',
      component: () => import('./views/upload_documentation_byinvitation_byuser.vue'),
    },
    {
      path: '/updatedocumentation/:idInvitationByUser',
      name: 'update_documentation_byinvitation_byuser',
      component: () => import('./views/update_documentation_byinvitation_byuser.vue'),
    },
    {
      path: '/booking',
      name: 'booking',
      component: () => import('./views/adminuser/algooo.vue'),
    },
    {
      path: '/qrcode/:qrcode',
      name: 'qr_code',
      component: () => import('./views/qr_code.vue'),
    },
    {
      path: '/healthy_format/:token',
      name: 'healthy_format',
      component: () => import('./views/healthy_format'),
    },
    {
      path: '/business_card/:id',
      name: 'business_card',
      component: () => import('./views/business_card'),
    },
    {
      path: '/qrcodeelevator/:qrcode',
      name: 'qr_code_elevator',
      component: () => import('./views/qr_code_elevator.vue'),
    },
    {
      path: '/qrcodepark/:qrcode',
      name: 'qr_code_park',
      component: () => import('./views/qr_code_park.vue'),
    },
    {
      path: '/registro/exito',
      name: 'registro',
      component: () => import('./views/registro_exito.vue'),
    },
    {
      path: '/registro/proveedor/exito',
      name: 'registro_proveedor_exito',
      component: () => import('./views/registro_proveedor_exito.vue'),
    },
    {
      path: '/confirmaridentidad/:token',
      name: 'confirmar_identidad',
      component: () => import('./views/confirmar_identidad.vue'),
      beforeEnter: ifAuthenticated_confirm,
    },
    {
      path: '/confirmaridentidad2/:token',
      name: 'confirmar_identidad2',
      component: () => import('./views/confirmar_identidad2.vue'),
      beforeEnter: ifAuthenticated_confirm,
    },
    {
      path: '/authorized_access/:idInvitationByUser',
      name: 'authorized_access',
      component: () => import('./views/authorized_access.vue'),
      beforeEnter: ifAuthenticated_authorized_access,
    },
    {
      path: '/authorized_access_no_code/:idBitacora',
      name: 'authorized_access_no_code',
      component: () => import('./views/authorized_access_no_code.vue'),
      beforeEnter: ifAuthenticated_authorized_access_no_code,
    },
    {
      path: '/confirmar_exito',
      name: 'confirmar_exito',
      component: () => import('./views/confirmar_exito.vue'),
      // beforeEnter: ifAuthenticated,
    },
    {
      path: '/confirmar_desconocido',
      name: 'confirmar_desconocido',
      component: () => import('./views/confirmar_desconocido.vue'),
      // beforeEnter: ifAuthenticated,
    },
    {
      path: '/password_reset',
      name: 'password_reset',
      component: () => import('./views/password_reset.vue'),
      // beforeEnter: ifAuthenticated,
    },
    {
      path: '/password_reset_done',
      name: 'password_reset_done',
      component: () => import('./views/password_reset_done.vue'),
      // beforeEnter: ifAuthenticated,
    },
    {
      path: '/form_proveedor/:token',
      name: 'form_proveedor',
      component: () => import('./views/form_proveedor.vue'),
      // beforeEnter: ifAuthenticated,
    },
    {
      path: '/providerFromUser/:token',
      name: 'providerFromUser',
      component: () => import('./views/providerFromUser')
    },
    {
      path: '/configuracion',
      name: 'configuracion',
      component: () => import('./views/configuracion.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/pesaje',
      name: 'scale_weighing',
      component: () => import('./views/ScaleWeighing.vue'),
      beforeEnter: ifVigilante,
    },
    {
      path: '/reservations_owner',
      name: 'reservations_owner',
      component: () => import('./views/adminuser/reservations_owner.vue'),
      beforeEnter: ifAuthenticated,
      meta: { requiresRole: [5] }
    },
    {
      path: '/reservations_beneficiary',
      name: 'reservations_beneficiary',
      component: () => import('./views/adminuser/reservations_beneficiary.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/reservations_history',
      name: 'reservations_history',
      component: () => import('./views/adminuser/reservations_history.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/shipments/authorization-request/:qr_code',
      name: 'shipment_authorization_request',
      component: () => import('./views/ShipmentAuthorizationRequest.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: "*",
      name: '404',
      component: () => import('./views/404.vue'),
    }
  ]
})

// Rutas a las que un guardia (roll 9) puede acceder aunque no tenga turno activo.
const GUARD_ALLOWED_PATHS_WITHOUT_SHIFT = ['/home', '/']

// Guard global: bloquea TODA la aplicación para guardias (roll 9) que no hayan
// iniciado turno.
router.beforeEach((to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next()
    return
  }

  if (GUARD_ALLOWED_PATHS_WITHOUT_SHIFT.includes(to.path)) {
    next()
    return
  }

  const evaluate = (profile) => {
    const isSecurityGuard = profile && profile.roll === 9
    if (!isSecurityGuard) {
      next()
      return
    }

    const activeShift = store.getters['security/getActiveShift']
    if (activeShift) {
      next()
    } else {
      next('/home')
    }
  }

  if (store.getters.isProfileLoaded) {
    evaluate(store.getters.getProfile)
    return
  }

  store.dispatch(USER_REQUEST)
    .then(() => evaluate(store.getters.getProfile))
    .catch(() => next('/'))
})

export default router
